<template>
  <div>
    <v-container fluid>
      <v-skeleton-loader :loading="!flagNav" transition="scale-transition" max-height="64" type="table-heading">
        <v-toolbar :image="SubNavbarBackGround" color="primary" class="header-title text-white">
          <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ $t('API External Log') }}</v-toolbar-title>
          <v-spacer />
          <div class="d-flex pr-4">
            <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ today }}</v-toolbar-title>
          </div>
        </v-toolbar>
      </v-skeleton-loader>

      <v-card class="card2" style="margin-top: 1rem">
        <v-card-text>
          <div class="mx-1 pa-4 search-panel">
            <v-row>
              <v-col cols="12" md="4" style="display: flex; align-items: center">
                <v-text-field
                  id="username-field-search-usermanagement"
                  :label="'API Endpoint'"
                  density="comfortable"
                  variant="outlined"
                  prepend-inner-icon="mdi-text-box-search-outline"
                  hide-details
                  clearable
                  v-model="apiEndPoint"
                  color="primary"
                  class="api-endpoint-field"
                ></v-text-field>
              </v-col>

              <!-- <v-col cols="12" md="4" style="display: flex; align-items: center">
                <v-text-field
                  id="username-field-search-usermanagement"
                  label="Search..."
                  density="comfortable"
                  variant="outlined"
                  prepend-inner-icon="mdi-text-box-search-outline"
                  hide-details
                  clearable
                  v-model="search"
                  color="primary"
                ></v-text-field>
              </v-col> -->

              <v-col md="8" cols="12" style="display: flex; align-items: center; justify-content: space-between; gap: 1rem">
                <v-btn variant="text" size="large" class="search-btn" @click="searchData" prepend-icon="mdi-magnify">
                  {{ $t('Search') }}
                </v-btn>
                <div class="d-flex align-center" style="gap: 1rem;">
                  <v-btn variant="text" size="large" class="export-btn" @click="exportToExcel" prepend-icon="mdi-file-export">
                  {{ $t('Export') }}
                  </v-btn>
                  <v-btn class="filter-btn" @click.stop="drawer = !drawer" icon="mdi-filter-variant" size="large"></v-btn>
                </div>
              </v-col>
            </v-row>
          </div>

          <!-- table -->
          <div class="template-table-wrapper mx-2">
            <v-data-table-server
              v-model:options="option"
              :items-per-page="option.itemsPerPage"
              :items-length="searchTotalTable"
              :items="apiExternalData"
              :headers="headers"
              :footer-props="{
                'items-per-page-options': [5, 10, 25, 50, 100],
              }"
              class="template-table modern-table"
              density="comfortable"
              hover
              :loading="loadingTable" 
            >
              <template #top>
                <v-toolbar flat color="grey-lighten-4" class="table-toolbar">
                  <v-toolbar-title class="text-h6 font-weight-medium">
                    <v-icon class="mr-2" color="primary">mdi-table</v-icon>
                    Api External Log ({{ searchTotalTable }} records)
                  </v-toolbar-title>
                </v-toolbar>
              </template>
              <template v-slot:item="{ item, index }">
                <tr>
                  <td style="text-align: center">{{ (option.page - 1) * option.itemsPerPage + index + 1 }}</td>
                  <td style="text-align: center; max-width: 160px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                    <v-tooltip v-if="item.transactionID && item.transactionID.length > 20" location="top">
                      <template #activator="{ props }">
                        <span v-bind="props" style="cursor: pointer;">
                          {{ item.transactionID.slice(0, 20) + '...' }}
                        </span>
                      </template>
                      <span>{{ item.transactionID }}</span>
                    </v-tooltip>
                    <span v-else>
                      {{ item.transactionID ? item.transactionID : '-' }}
                    </span>
                  </td>
                  <td style="text-align: center">
                    <div
                      style="padding: 4px; border-radius: 5px"
                      :style="[
                        item.method === 'GET'
                          ? 'background-color: #e3f2fd'
                          : item.method === 'POST'
                          ? 'background-color: #e8f5e9'
                          : item.method === 'PUT'
                          ? 'background-color: #fff3e0'
                          : item.method === 'DELETE'
                          ? 'background-color: #ffebee'
                          : '',
                      ]"
                    >
                      {{ item.method }}
                    </div>
                  </td>
                  <td style="text-align: center; max-width: 220px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                    <v-tooltip location="top">
                      <template #activator="{ props }">
                        <span v-bind="props" style="cursor: pointer;">
                          {{ item.apiEndPoint }}
                        </span>
                      </template>
                      <span>{{ item.apiEndPoint }}</span>
                    </v-tooltip>
                  </td>
                  <td style="text-align: center">{{ item.statusCode }}</td>
                  <td style="text-align: center; max-width: 160px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                    <v-tooltip v-if="item.createBy && item.createBy.length > 20" location="top">
                      <template #activator="{ props }">
                        <span v-bind="props" style="cursor: pointer;">
                          {{ item.createBy.length > 20 ? item.createBy.slice(0, 20) + '...' : item.createBy }}
                        </span>
                      </template>
                      <span>{{ item.createBy }}</span>
                    </v-tooltip>
                    <span v-else>
                      {{ item.createBy }}
                    </span>
                  </td>
                  <td style="text-align: center">{{ formatDateTable(item.createDate) }}</td>
                  <td style="text-align: center">
                    <v-col cols="auto">
                      <v-btn variant="tonal" color="primary" @click="GetApiExternalById(item.apiExternalID)" icon="mdi-magnify" size="x-small"></v-btn>
                    </v-col>
                  </td>
                </tr>
              </template>

              <template #no-data>
                <div class="text-center pa-8">
                  <v-icon size="48" color="grey-lighten-1" class="mb-4">mdi-database-off</v-icon>
                  <h3 class="text-grey-lighten-1 mb-2">{{ $t('No data available') }}</h3>
                  <p class="text-grey-lighten-2">{{ $t('No API logs found matching your criteria') }}</p>
                </div>
              </template>
            </v-data-table-server>
          </div>
        </v-card-text>
      </v-card>
    </v-container>

    <!-- drawer -->
    <v-navigation-drawer :width="400" location="right" v-model="drawer" :location="$vuetify.display.mobile ? 'bottom' : undefined" temporary>
      <v-row class="pa-4">
        <v-col cols="12" class="filter-title">
          <v-card-title class="text-h6">Filter Options</v-card-title>
          <v-btn variant="tonal" color="primary" size="small" icon="mdi-close"  @click="drawer = false"></v-btn>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-card-text>
        <v-row>
          <!-- transaction id -->
          <v-col cols="12" md="12">
            <v-text-field label="Transaction ID" v-model="filter.transactionID" variant="outlined" prepend-inner-icon="mdi-numeric" hide-details clearable></v-text-field>
          </v-col>
          <!-- method -->
          <v-col cols="12" md="6">
            <v-select label="Method" :items="['GET', 'POST', 'PUT', 'DELETE']" v-model="filter.method" variant="outlined"></v-select>
          </v-col>
          <!-- Status Code -->
          <v-col cols="12" md="6">
            <v-text-field label="Status Code" v-model="filter.statusCode" variant="outlined" prepend-inner-icon="mdi-numeric" hide-details clearable></v-text-field>
          </v-col>
          <!-- Create By -->
          <v-col cols="12" md="12">
            <v-text-field label="Create By" v-model="filter.createBy" variant="outlined" prepend-inner-icon="mdi-numeric"></v-text-field>
          </v-col>

          <v-col md="6">
            <v-menu v-model="filter.startDateFlag" :close-on-content-click="false" transition="scale-transition" location="bottom" min-width="auto">
              <template #activator="{ props }">
                <v-text-field
                  v-model="filter.startDate"
                  label="Start Date"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  variant="outlined"
                  v-bind="props"
                  density="comfortable"
                  color="primary"
                  class="date-field"
                >
                  <template #append-inner>
                    <v-tooltip location="top" max-width="200">
                      <template #activator="{ props }">
                        <v-icon size="small" color="grey-darken-1" v-bind="props">mdi-information-outline</v-icon>
                      </template>
                      <span>Select start date for filtering</span>
                    </v-tooltip>
                  </template>
                </v-text-field>
              </template>
              <v-date-picker
                v-model="startDate"
                @update:model-value="
                  (val) => {
                    filter.startDate = formatDate(val);
                    filter.startDateFlag = false;
                  }
                "
                color="primary"
                :max="new Date()"
              ></v-date-picker>
            </v-menu>
          </v-col>

          <v-col md="6">
            <v-menu v-model="filter.endDateFlag" :close-on-content-click="false" transition="scale-transition" location="bottom" min-width="auto">
              <template #activator="{ props }">
                <v-text-field v-model="filter.endDate" label="End Date" prepend-inner-icon="mdi-calendar" readonly variant="outlined" v-bind="props" density="comfortable" color="primary" class="date-field">
                  <template #append-inner>
                    <v-tooltip location="top" max-width="200">
                      <template #activator="{ props }">
                        <v-icon size="small" color="grey-darken-1" v-bind="props">mdi-information-outline</v-icon>
                      </template>
                      <span>Select start date for filtering</span>
                    </v-tooltip>
                  </template>
                </v-text-field>
              </template>
              <v-date-picker
                v-model="filter.endDate"
                :min="filter.startDate"
                @update:model-value="
                  (val) => {
                    filter.endDate = formatDate(val);
                    filter.endDateFlag = false;
                  }
                "
                color="primary"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>

      <template v-slot:append>
        <v-row class="pa-4">
          <v-col md="6">
            <!-- button full width -->
            <v-btn variant="outlined" color="primary" class="apply-filter-btn w-100" @click="clearAll">Clear All</v-btn>
          </v-col>
          <v-col md="6" class="text-right">
            <v-btn color="primary" class="apply-filter-btn w-100" @click="applyFilter">Apply Filter</v-btn>
          </v-col>
        </v-row>
      </template>
    </v-navigation-drawer>

    <!-- dialog API External Detail -->
    <v-dialog max-width="800" max-height="600" v-model="dialogApiExternalDetail" persistent>
      <template v-slot:default>
        <v-card title="API External Detail" >
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <div class="d-flex align-center">
                  <h4 class="mr-2">Transaction ID:</h4>
                  <pre class="font-detail mb-0">{{ apiExternalDetail.transactionID ? apiExternalDetail.transactionID : '-' }}</pre>
                </div>
              </v-col>
              <v-col cols="12">
                <h4>API Endpoint:</h4>
                <span class="font-detail">{{ apiExternalDetail.apiEndPoint }}</span>
              </v-col>
              <v-col cols="12">
                <div class="d-flex align-center">
                  <h4 class="mr-2">Method:</h4>
                  <span class="font-detail mb-0">{{ apiExternalDetail.method }}</span>
                </div>
              </v-col>
              <v-col cols="12">
                <div class="d-flex align-center">
                  <h4 class="mr-2">Status Code:</h4>
                  <span class="font-detail mb-0">{{ apiExternalDetail.statusCode }}</span>
                </div>
              </v-col>
              <v-col cols="12">
                <div class="d-flex align-center">
                  <h4 class="mr-2">Create By :</h4>
                  <span class="font-detail mb-0">{{ apiExternalDetail.createBy }}</span>
                </div>
              </v-col>
              <v-col cols="12">
                <div class="d-flex align-center">
                  <h4 class="mr-2">Create Date :</h4>
                  <span class="font-detail mb-0">{{ formatDateTable(apiExternalDetail.createDate) }}</span>
                </div>
              </v-col>

              <v-expansion-panels>
                <v-expansion-panel class="response-panel" title="Request Body">
                  <v-expansion-panel-text>
                    <!-- <span>{{ apiExternalDetail.requestBody }}</span> -->
                    <div class="response-container">
                      <pre class="content">{{ apiExternalDetail.requestBody }}</pre>
                    </div>
                  </v-expansion-panel-text>
                </v-expansion-panel>
              </v-expansion-panels>

              <v-expansion-panels class="mt-2" variant="accordion" style="">
                <v-expansion-panel class="response-panel" title="JSON Response">
                  <v-expansion-panel-text>
                    <div class="response-container">
                      <pre class="content">{{ apiExternalDetail.jsonResponse }}</pre>
                    </div>
                  </v-expansion-panel-text>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-row>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn variant="outlined" color="primary" class="ms-auto" text="Close" @click="dialogApiExternalDetail = false"></v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <!-- loading Pleas wait -->
    <v-dialog :model-value="dialog" class="align-center justify-center" persistent max-width="350px">
      <v-card class="loading-card" elevation="8">
        <v-card-text class="text-center">
          <v-progress-circular indeterminate size="64" color="primary" class="mb-4"></v-progress-circular>
          <h3 class="loading-title">Loading...</h3>
          <p class="loading-subtitle">Please wait</p>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import dateUtils from '../plugins/date-utils';
import moment from 'moment';

export default {
  name: 'LogAPIExternal',
  inject: ['SubNavbarBackGround', 'FontColorTitle', 'flagNav'],

  data() {
    return {
      apiExternalData: [],
      apiEndPoint: '',
      headers: [],
      today: null,
      dialog: false,
      drawer: false,
      dialogApiExternalDetail: false,

      filter: {
        transactionID: '',
        method: null,
        statusCode: '',
        createBy: '',
        endDate: null,
        endDateFlag: false,
        startDate: null,
        startDateFlag: false,
      },
      option: {
        itemsPerPage: 10,
        page: 1,
        sortBy: [],
        sortDesc: [],
      },
      
      searchTotalTable: 0,
    };
  },

  methods: {
    searchData() {
      this.GetApiExternal();
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = '0' + dd;
      }
      if (mm < 10) {
        mm = '0' + mm;
      }

      this.today = dd + '/' + mm + '/' + yyyy;
    },

    GetApiExternal() {
      this.loadingTable = true;

      let { page, itemsPerPage, sortBy } = this.option;
      let sortField = null;
      let sortOrder = null;
      if (sortBy && sortBy.length > 0) {
        sortField = sortBy[0].key;
        sortOrder = sortBy[0].order === 'desc';
      }

      let temp = {
        // Pagination parameters
        page: page,
        itemsPerPage: itemsPerPage,
        sortBy: sortField,
        sortDesc: sortOrder,

        apiEndPoint: this.apiEndPoint,

        // Filter parameters
        transactionID: this.filter.transactionID,
        method: this.filter.method,
        statusCode: this.filter.statusCode,
        createBy: this.filter.createBy,
        startDate: this.filter.startDate == null ? this.formatDate(new Date()) : this.filter.startDate,
        endDate: this.filter.endDate == null ? this.formatDate(new Date()) : this.filter.endDate,
      };
      this.$call.GetApiExternal(
        temp,
        (response) => {
          if (response.status == 0) {
            this.searchTotalTable = response.data.total;
            this.apiExternalData = response.data.data;
            this.option.page = response.data.page;
          } else {
            this.searchTotalTable = 0;
            this.apiExternalData = [];
          }
          this.loadingTable = false;
        },
        (error) => {
          this.loadingTable = false;
          console.error('Error fetching API external logs:', error);
        }
      );
    },

    GetApiExternalById(id) {
      this.dialog = true;
      this.$call.GetApiExternalById(
        id,
        (response) => {
          if (response.status == 0) {
            this.apiExternalDetail = response.data.data;
            this.dialog = false;
            this.dialogApiExternalDetail = true;
          } else {
            this.apiExternalDetail = {};
            this.dialogApiExternalDetail = false;
            console.error('Error fetching API external log details:', response.message);
          }
          this.dialog = false;
        },
        (error) => {
          this.dialog = false;
          console.error('Error fetching API external log by ID:', error);
        }
      );
    },

    formatDateTable(date) {
      const d = new Date(date);
      const day = String(d.getDate()).padStart(2, '0');
      const month = String(d.getMonth() + 1).padStart(2, '0'); // Months are zero-based
      const year = d.getFullYear();
      const hours = String(d.getHours()).padStart(2, '0');
      const minutes = String(d.getMinutes()).padStart(2, '0');
      const seconds = String(d.getSeconds()).padStart(2, '0');
      return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    },

    formatDate(dateInput) {
      if (!dateInput) {
        return '';
      }
      if (typeof dateInput === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(dateInput)) {
        return dateInput;
      }

      const d = new Date(dateInput);
      if (isNaN(d.getTime())) {
        return dateInput.toString().substr(0, 10);
      }

      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      const date = `${year}-${month}-${day}`;
      return date;
    },

    clearAll() {
      this.filter.transactionID = '';
      this.filter.method = null;
      this.filter.statusCode = '';
      this.filter.createBy = '';
      this.filter.startDate = this.formatDate(new Date());
      this.filter.endDate = this.formatDate(new Date());
      this.GetApiExternal();
      this.drawer = false;
    },
    applyFilter() {
      this.drawer = false;
      this.GetApiExternal();
    },
    convertDateToString2(date, seperator = '-') {
      return dateUtils.getStringFromDatePickFormatDatePick2(moment(date).toDate(), seperator);
    },
    convertDateToString(date, seperator = '/') {
            return dateUtils.getStringWithTimeFromDate(moment(date).toDate(), seperator);
    }, 
    exportToExcel(){
      this.dialog = true;

      let { page, itemsPerPage, sortBy } = this.option;
      let sortField = null;
      let sortOrder = null;
      if (sortBy && sortBy.length > 0) {
        sortField = sortBy[0].key;
        sortOrder = sortBy[0].order === 'desc';
      }

      let temp = {
        // Pagination parameters
        page: page,
        itemsPerPage: itemsPerPage,
        sortBy: sortField,
        sortDesc: sortOrder,

        apiEndPoint: this.apiEndPoint,

        // Filter parameters
        transactionID: this.filter.transactionID,
        method: this.filter.method,
        statusCode: this.filter.statusCode,
        createBy: this.filter.createBy,
        startDate: this.filter.startDate,
        endDate: this.filter.endDate,
      };
      this.$call.ExportApiExternal(
        temp,
        (dataResponse) => {
          if (dataResponse) {
            let fileURL = window.URL.createObjectURL(new Blob([dataResponse]));
            let fileLink = document.createElement('a');

            fileLink.href = fileURL;

            let fileNameshow = `API_LOG_${this.convertDateToString(new Date(), '')}.xlsx`;
            fileLink.setAttribute('download', fileNameshow);
            document.body.appendChild(fileLink);

            fileLink.click();
          }
          this.dialog = false;
        },
        (error) => {
          this.dialog = false;
          console.error('Error exporting API external logs:', error);
        }
      );
    }
  },

  watch: {
    option: {
      handler() {
        this.GetApiExternal();
      },
      deep: true,
      immediate: false,
    },
  },

  mounted() {
    this.headers = [
      {
        title: this.$t('no'),
        align: 'center',
        sortable: false,
      },
      {
        title: this.$t('Transaction ID'),
        align: 'center',
        sortable: true,
        value: 'transactionID',
      },
      {
        title: this.$t('method'),
        align: 'center',
        sortable: true,
        value: 'method',
      },
      {
        title: this.$t('Api EndPoint'),
        align: 'center',
        sortable: true,
        value: 'Api EndPoint',
      },
      { title: 'Status code', align: 'center', sortable: true, value: 'statusCode' },
      {
        title: this.$t('Create by'),
        align: 'center',
        sortable: false,
        value: 'createdBy',
      },
      {
        title: this.$t('Create date'),
        align: 'center',
        sortable: true,
        value: 'createdDate',
      },
      {
        title: this.$t('Details'),
        align: 'center',
        sortable: false,
      },
    ];
    this.filter.startDate = this.formatDate(new Date());
    this.filter.endDate = this.formatDate(new Date());
    this.GetDate();
    // this.GetApiExternal();
  },
};
</script>

<style scoped>
/* fileter button */
.filter-btn {
  background: linear-gradient(45deg, #371f4c, #874dab);
  color: white;
  border-radius: 50%;
}

/* table */
.template-table-wrapper {
  margin-top: 1rem;
  background: white;
  border-radius: 12px;
  overflow: hidden;
  /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); */
}

/* dialog detail */
.font-detail {
  white-space: pre-wrap;
  word-break: break-all;
  font-weight: 700;
  color: #333;
  font-size: 14px;
}

.search-btn {
  /* background primary */
  background: linear-gradient(45deg, #1565C0, #42A5F5);
  color: white;
  border-radius: 16px !important;
}

/* export-btn */
.export-btn {
  background: linear-gradient(45deg, rgb(27, 112, 34), rgba(55, 189, 66, 0.652));
  color: white;
  border-radius: 16px !important;
}

.filter-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 0.5rem;
  border-bottom: rgb(229, 229, 229) solid 1px;
}

.apply-filter-btn {
  color: white;
  border-radius: 10px !important;
  padding: 0.5rem 1rem;
  font-weight: 500;
}

/* JSON Response Panel Styling */
.response-panel {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.response-panel:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.response-container {
  background: #f8f9fa;
  border-radius: 4px;
  margin: 8px;
  border: 1px solid #e9ecef;
  max-height: 400px;
  overflow-y: auto;
}

.content {
  background: #2d3748;
  color: #e2e8f0;
  padding: 20px;
  margin: 0;
  font-family: 'Monaco', 'Fira Code', monospace;
  font-size: 13px;
  line-height: 1.5;
  white-space: pre-wrap;
  border-radius: 4px;
}

.content::-webkit-scrollbar {
  width: 8px;
}

.content::-webkit-scrollbar-thumb {
  background: #718096;
  border-radius: 4px;
}

.modern-table :deep(.v-table__wrapper) {
  max-height: 600px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(25, 118, 210, 0.3) rgba(0, 0, 0, 0.05);
}

.modern-table :deep(.v-table__wrapper thead th) {
  position: sticky;
  top: 0;
  z-index: 2;
  background: rgb(var(--v-theme-surface, 255, 255, 255));
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar) {
  width: 6px;
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar-track) {
  background: rgba(0, 0, 0, 0.05);
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar-thumb) {
  background: rgba(25, 118, 210, 0.3);
  border-radius: 3px;
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar-thumb:hover) {
  background: rgba(25, 118, 210, 0.5);
}
</style>
